module.exports = __webpack_public_path__ + "img/22029d3.jpg";